<script setup lang='ts'>
import type { BannerProps } from "./type";

import Catalog from "./Catalog.vue";
import { useBannerHook } from "./hooks";
import { LettersFIcon } from "tdesign-icons-vue-next";

defineOptions({
  name: "Banner",
});

const props = withDefaults(defineProps<BannerProps>(), {
  func: "back",
  border: true,
  transparent: false,
});

const emit = defineEmits(["back:security"]);
function handleSecurity() {
  // console.log(emit)
  emit("back:security");
}

const { openCatalog, handleLeftClick } = useBannerHook();
</script>

<template>
  <!-- TODO: v-bind="$attrs" 似乎不管用 -->
  <t-navbar
    :fixed="true"
    :title="props.title"
    :left-arrow="
      props.func === 'back' || props.func === 'home' || props.func === 'search'
    "
    v-bind="$attrs"
    :class="[
      props?.border && 'show-border',
      props?.transparent && 'transparent',
    ]"
    style="z-index: 9"
    @left-click="handleLeftClick(func)"
  >
    <!-- <template v-if="func === 'menu'" #left>
      <ViewListIcon size="20px" />
      <slot />
    </template> -->
    <template v-if="func === 'security'" #left>
      <ChevronLeftIcon size="24px" @click="handleSecurity" />
    </template>
    <template v-if="func === 'bbs'" #left>
      <!-- <t-image
        class="w-[32px] h-[32px]"
        src="https://tdesign.gtimg.com/demo/demo-image-1.png"
        fit="cover"
        shape="circle"
      /> -->
      <span class="text-sm font-semibold">论坛</span>
    </template>

    <template v-for="(val, name) in $slots" #[name]="soltData">
      <slot :name="name" v-bind="soltData || {}" />
    </template>
  </t-navbar>
</template>

<style lang='scss' scoped>
.show-border {
  :deep(.t-navbar__center) {
    border-bottom: 0.5px solid #e7e7e7;

    .t-navbar__center-title {
      width: 80%;
    }
  }
}
.transparent {
  :deep(.t-navbar__content) {
    background-color: transparent;
  }
}
</style>
